import React from 'react';
import { useTranslation } from 'react-i18next';
import { VerifiedShop } from '../services/orderLookupService';
import LanguageSwitcher from './LanguageSwitcher';
import { useStartTexts } from '../i18n/useStartTexts';

// #105 (S1, plan D6): the portal header (mockup .p-head). The shop name is
// plain text: on the full-screen QR entry it comes from the verified shop
// (#72: a link built only from the verified domain, no logo); otherwise only
// the caption shows (the order lookup carries no shop name and nothing is
// read from a remembered shop). The language pill keeps the staticOnly
// behaviour of LanguageSwitcher.
interface Props {
  shop: VerifiedShop | null;
  showLanguageSelector: boolean;
  staticOnly: boolean;
  // #493 (S3): on the returns flow the caption is the shop's `start_header`
  // (selected language only, static fallback); never on `/withdrawal/*`, the
  // status page or the standalone QR
  startTexts?: boolean;
}

const PortalHeader: React.FC<Props> = ({
  shop,
  showLanguageSelector,
  staticOnly,
  startTexts = false,
}) => {
  const { t } = useTranslation(['translation', 'dynamic']);
  const start = useStartTexts(startTexts);
  return (
    <header className="xc-head">
      <div className="xc-shop">
        {shop && (
          <span className="xc-shop__name">
            <a href={`https://${shop.domain}`} rel="noopener noreferrer">
              {shop.name ?? shop.domain}
            </a>
          </span>
        )}
        {/* empty while the start form waits for the shop texts (gate) */}
        <small>
          {start.ready
            ? (start.text('start_header', 'header.returns') ??
              t('header.returns'))
            : null}
        </small>
      </div>
      {showLanguageSelector && (
        <LanguageSwitcher staticOnly={staticOnly} startTexts={startTexts} />
      )}
    </header>
  );
};

export default PortalHeader;
